<template>
  <div id="filter-radar-grid-type">
    <vs-row vs-type="flex" class="mt-1">
      <vs-col
        vs-order="1"
        vs-type="flex"
        vs-justify="center"
        vs-align="center"
        vs-w="1"
      >
        <img
          class="filter-radar-grid-img"
          src="@/assets/images/radarGrid/radar_grid.svg"
        />
      </vs-col>
      <vs-col
        vs-order="2"
        vs-type="flex"
        vs-justify="start"
        vs-align="center"
        vs-w="7"
      >
        <span class="aisea-text-16-400-white ml-5">レーダー捕捉物体</span>
      </vs-col>
      <vs-col
        vs-order="3"
        vs-type="flex"
        vs-justify="flex-end"
        vs-align="center"
        vs-w="4"
      >
        <vs-switch :color="AISEA_COLOR.BLUE" v-model="radarGridToggle" />
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import { ColorMixin } from "@/mixins";
import FireStoreService from "@/services/fireStoreService";
import { mapGetters, mapMutations } from "vuex";
import debounce from "lodash/debounce";
import LocalDbService from "@/services/localDbService";
import Vue from "vue";

const RADAR_GRID_KEY = "radar_grid";

export default {
  name: "RadarGridType",
  mixins: [ColorMixin],

  computed: {
    ...mapGetters("liveMap", {
      filterRadarGrid: "getFilterRadarGrid",
    }),

    radarGridToggle: {
      get() {
        return this.filterRadarGrid.includes(RADAR_GRID_KEY);
      },
      set(value) {
        let updated = [...this.filterRadarGrid];
        if (value && !updated.includes(RADAR_GRID_KEY)) {
          updated.push(RADAR_GRID_KEY);
        } else if (!value) {
          updated = updated.filter(v => v !== RADAR_GRID_KEY);
        }
        this.setFilterRadarGrid(updated);
        this.saveFilterRadarGrid(updated);
      },
    },
  },

  methods: {
    ...mapMutations("liveMap", {
      setFilterRadarGrid: "SET_FILTER_RADAR_GRID",
    }),

    saveFilterRadarGrid: debounce(async function(updated) {
      try {
        await FireStoreService.saveFilterRadarGrid(updated);
        await LocalDbService.saveFilterRadarGrid(updated);
      } catch (e) {
        Vue.$log.error("フィルター保存に失敗:", e);
      }
    }, 500),

    async setFilterSwitch(filterRadarGrid) {
      this.setFilterRadarGrid(filterRadarGrid);
    },
  },

  async created() {
    let filterRadarGrid = await LocalDbService.getFilterRadarGrid();
    if (filterRadarGrid.length === 0) {
      this.setFilterRadarGrid([RADAR_GRID_KEY]);
    } else {
      await this.setFilterSwitch(filterRadarGrid);
    }
  },
};
</script>

<style lang="scss">
@import "src/assets/scss/aisea/variables";

#filter-radar-grid-type {
  background: $aisea-blue-gray;

  .filter-radar-grid-img {
    height: 20px;
    width: 20px;
  }
}
</style>
